export const HomeResources = {
    SEARCH_TITLE: 'Find The Best Domain for Your Business',
    SEARCH_TITLE_SEARCH_PAGE: 'Search Domain',
    SEARCH_DES: `Your domain name is where you make your first impression. It's where you build credibility, and how you're found. Stand out with a domain name that's perfectly you.`,
    SEARCH_PLACEHOLDER: 'Search your domain',
    DOMAIN_LIST_TITLE: 'The most popular top domain names that fit you best',
    PRICE_TEMPLATE: (price: number) => `৳ ${price}/yr`,
    DOMAIN_LIST: [
        { title: '.COM', price: 950, dPrice: 750, des:"Domain for your company" },
        { title: '.ORG', price: 550, dPrice: 650, des:"Domain for your Organigation" },
        { title: '.ME', price: 950, dPrice: 750, des: "Domain for your persoanl website" },
        { title: '.TECH', price: 750, dPrice: 450, des:"Domain for your company" },
        { title: '.CO', price: 950, dPrice: 750, des:"Domain for your Organigation" },
        { title: '.CF', price: 0, dPrice: 0, des:"Domain for your persoanl website" },
        { title: '.ML', price: 0, dPrice: 0, des:"Domain for your company" },
        { title: '.IN', price: 550, dPrice: 650, des:"Domain for your Organigation" },
        { title: '.BD', price: 950, dPrice: 750, des: "Domain for your persoanl website" },
        { title: '.US', price: 750, dPrice: 450, des:"Domain for your company" },
        { title: '.LIVE', price: 950, dPrice: 750, des:"Domain for your Organigation" },
        { title: '.CLUB', price: 950, dPrice: 750, des:"Domain for your persoanl website" },
    ],
};
